const init = () => {
  if (document.querySelector('header.tw-sticky')) {
    const header = document.querySelector('header.tw-sticky');
    document.addEventListener('scroll', () => {
      if (window.pageYOffset > 0 && !header.classList.contains('tw-shadow-md')) {
        header.classList.add('tw-shadow-md');
        header.classList.add('tw-shadow-md');
      }
      if (window.pageYOffset <= 0 && header.classList.contains('tw-shadow-md')) {
        header.classList.remove('tw-shadow-md');
        header.classList.remove('tw-shadow-md');
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', init);
